import { z } from 'zod';

import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';
import { NullableStringSchema, RequiredStringSchema } from '../common';

export const PayorParamsSchema = z.object({
  payor: NullableStringSchema,
  payorPlan: NullableStringSchema,
  specialty: NullableStringSchema,
  patient: z.object({
    firstName: RequiredStringSchema,
    lastName: RequiredStringSchema,
    dateOfBirth: RequiredStringSchema,
  }),
  insurance: z
    .object({
      memberId: NullableStringSchema,
    })
    .nullable()
    .optional()
    .default(null),
});

export function PayorParamsFormFields() {
  return (
    <>
      <BlockValueTemplateField
        fieldName="config.payload.payor"
        label="Payor"
        helperText="Enter the reference to the Payor. e.g. `{{patient.data.payor}}`"
        placeholder="e.g. {{patient.data.payor}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.payorPlan"
        label="Payor Plan"
        helperText="Enter the reference to the Payor Plan. e.g. `{{patient.data.payorPlan}}`"
        placeholder="e.g. {{patient.data.payorPlan}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.specialty"
        label="Specialty"
        helperText="Enter the reference to the Specialty. e.g. `{{patient.data.specialty}}`"
        placeholder="e.g. {{patient.data.specialty}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.patient.firstName"
        label="Patient First Name"
        helperText="Enter the reference to the Patient First Name. e.g. `{{patient.data.patient.firstName}}`"
        placeholder="e.g. {{patient.data.patient.firstName}}"
        required
      />
      <BlockValueTemplateField
        fieldName="config.payload.patient.lastName"
        label="Patient Last Name"
        helperText="Enter the reference to the Patient Last Name. e.g. `{{patient.data.patient.lastName}}`"
        placeholder="e.g. {{patient.data.patient.lastName}}"
        required
      />
      <BlockValueTemplateField
        fieldName="config.payload.patient.dateOfBirth"
        label="Patient Date of Birth"
        helperText="Enter the reference to the Patient Date of Birth. e.g. `{{patient.data.patient.dateOfBirth}}`"
        placeholder="e.g. {{patient.data.patient.dateOfBirth}}"
        required
      />
      <BlockValueTemplateField
        fieldName="config.payload.insurance.memberId"
        label="Insurance Member Id"
        helperText="Enter the reference to the Insurance Member Id. e.g. `{{patient.data.insurance.memberId}}`"
        placeholder="e.g. {{patient.data.insurance.memberId}}"
      />
    </>
  );
}
